import { render, staticRenderFns } from "./YsList.vue?vue&type=template&id=634aaa31&scoped=true&"
import script from "./YsList.vue?vue&type=script&lang=js&"
export * from "./YsList.vue?vue&type=script&lang=js&"
import style0 from "./YsList.vue?vue&type=style&index=0&id=634aaa31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634aaa31",
  null
  
)

export default component.exports